import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'pipeCalendarStatus'
})
export class PipeCalendarStatus implements PipeTransform {
    
    constructor() {}

    transform(event) {
        if (event && event.desk) {
        // Se evento for de Posição

            if(moment(event.start).toDate() < moment().toDate() && moment(event.end).toDate() > moment().toDate()){
                if (event.desk && event.desk.space && event.desk.space.default && 
                    event.desk.locale && event.desk.locale.checkin && event.checkin) {
                    return 'event-danger shadow';
                } else if (event.desk && event.desk.space && !event.desk.space.default && 
                    event.desk.space.checkin && event.checkin) {
                    return 'event-danger shadow';
                } else if ((event.desk && event.desk.space && !event.desk.space.default && 
                    !event.desk.space.checkin) || (event.desk && event.desk.space && event.desk.space.default && 
                    !event.desk.locale.checkin)) {
                    return 'event-danger shadow';
                } else {
                    return 'event-warning shadow';
                }
            } else if(moment(event.start).toDate() > moment().toDate() && 
                moment(event.start).toDate() <= moment().add(15, 'minutes').toDate()){
                return 'event-warning shadow';
            } else {
                return 'event-light shadow';
            }

        } else if (event && event.meetingrooms && event.meetingrooms.length > 0) {
        // Se evento for de Sala de Reunião
            
            if(moment(event.start).toDate() < moment().toDate() && moment(event.end).toDate() > moment().toDate()){
                if (event.meetingrooms[0] && event.meetingrooms[0].space && event.meetingrooms[0].space.default && 
                    event.meetingrooms[0].locale && event.meetingrooms[0].locale.checkin && (event.checkin || (event.scheduleOffice && event.scheduleOffice.checkinAt))) {
                    return 'event-danger shadow';
                } else if (event.meetingrooms[0] && event.meetingrooms[0].space && !event.meetingrooms[0].space.default && 
                    event.meetingrooms[0].space.checkin && (event.checkin || (event.scheduleOffice && event.scheduleOffice.checkinAt))) {
                    return 'event-danger shadow';
                } else if ((event.meetingrooms[0] && event.meetingrooms[0].space && !event.meetingrooms[0].space.default && 
                    !event.meetingrooms[0].space.checkin) || (event.meetingrooms[0] && event.meetingrooms[0].space && event.meetingrooms[0].space.default && 
                    !event.meetingrooms[0].locale.checkin)) {
                    return 'event-danger shadow';
                } else {
                    return 'event-warning shadow';
                }
            } else if(moment(event.start).toDate() > moment().toDate() && 
                moment(event.start).toDate() <= moment().add(15, 'minutes').toDate()){
                return 'event-warning shadow';
            } else {
                return 'event-light shadow';
            }
            
        } else if (event) {
        // Se for outro tipo de evento

            if(moment(event.start).toDate() < moment().toDate() && moment(event.end).toDate() > moment().toDate()){
                return 'event-danger shadow';
            } else if(moment(event.start).toDate() > moment().toDate() && 
                moment(event.start).toDate() <= moment().add(15, 'minutes').toDate()){
                return 'event-warning shadow';
            } else {
                return 'event-light shadow';
            }

        } else return 'event-light shadow';
    }

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeCalendarStatus.ts